<div>
  <div class="d-flex justify-content-center">
    <label [for]="id" class="form-label">
      <strong>{{ label }}</strong>
    </label>
  </div>

  <div class="position-relative">
    <input
      [id]="id"
      type="text"
      class="form-control mt-2 pe-5"
      [placeholder]="placeholder"
      [formControl]="searchInput"
      (blur)="onBlur()"
      (focus)="onFocus()"
      autocomplete="off"
    />

    @if (control.value) {
      <button
        type="button"
        class="btn btn-sm btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0 text-secondary text-decoration-none"
        aria-label="Pulisci selezione"
        (click)="clearSelection()">
        x
      </button>
    }

    @if (showDropdown && filteredOptions.length > 0) {
      <ul class="list-group list-group-flush w-100 shadow mt-1 position-absolute start-0 end-0 overflow-auto z-3" style="max-height: 220px;">
        @for (item of filteredOptions; track $index) {
          <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" (click)="selectItem(item)">
            <span class="text-truncate me-2">{{ displayFn(item) }}</span>
            @if (deleteItem.observed) {
              <button
                type="button"
                class="btn btn-sm btn-outline-danger border-0 p-1 lh-1 flex-shrink-0"
                title="Elimina luogo salvato"
                (click)="onDeleteItem($event, item)">
                <i class="bi bi-trash" aria-hidden="true"></i>
              </button>
            }
          </li>
        }
      </ul>
    }

    @if (showDropdown && filteredOptions.length === 0 && searchInput.value.length >= minSearchLength) {
      <ul class="list-group list-group-flush w-100 shadow mt-1 position-absolute start-0 end-0 overflow-auto z-3" style="max-height: 220px;">
        <li class="list-group-item text-muted">{{ noResultsText }}</li>
      </ul>
    }
  </div>
</div>

